// extracted by mini-css-extract-plugin
module.exports = {"topAlign":"post_update_error__topAlign___r1X-r","extraContent":"post_update_error__extraContent___rynOa"};